import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton({ className = "", label = "Back", to = -1, small = false }) {
  const navigate = useNavigate();

  const handleClick = () => {
    try {
      if (typeof to === 'string') {
        navigate(to);
      } else {
        navigate(to);
      }
    } catch (error) {
      console.error('BackButton navigation error:', error);
    }
  };

  const sizeClass = small
    ? 'p-1.5 min-w-0 rounded-lg border border-amber-200 shadow text-xs'
    : 'p-1 md:px-4 md:py-2 rounded-lg md:rounded-xl border-2 md:border-4 border-amber-200';
  const iconSize = small ? 'w-3.5 h-3.5' : 'w-3 h-3 md:w-4 md:h-4';

  return (
    <button
      onClick={handleClick}
      className={`flex items-center justify-center gap-0 md:gap-2 bg-amber-400 hover:bg-amber-500 text-white font-bold shadow border-amber-200 transition-all flex-shrink-0 ${sizeClass} ${className}`}
      style={{ fontFamily: 'inherit' }}
      title={label}
    >
      <ArrowLeft className={`${iconSize} flex-shrink-0 text-white`} />
      <span className={small ? 'hidden' : 'hidden md:inline ml-1 text-sm'}>{label}</span>
    </button>
  );
} 